import React, { useState, useEffect } from 'react'
import { Switch, Route, useHistory, Redirect } from 'react-router-dom'
import useSound from 'use-sound'
import notificationSound from '@/assets/sounds/new-message.mp3'
import LoadingScreen from '@/components/LoadingScreen'
import { SettingsPage, HomePage, LoginPage } from '@/pages'
import AuthService from '@/app-domains/user/auth/Auth.service'
import CommonsService from '@/services/commons.service'
import sessionService from '@/app-domains/user/session/session.service'
import log from '@/services/log.service'
import getEnvironmentConfiguration from './config'
import store from '@/core/store'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import FlagsService from './services/featureFlags/Flags.service'
import config from '@/config'
import { HeadersMenu } from './components'
import { MessageModal } from './components/WritingMessageModal'
import { SessionExpiredModal } from './components/SessionExpiredModal/SessionExpiredModal'
import { DropdownMenu } from './components/DropdownMenu/DropdownMenu'
import { KbarInput } from '@/components/KbarInput/KbarInput'
import {
  KBarProvider,
} from 'kbar'

getEnvironmentConfiguration()
AuthService.init()
if (config().REACT_APP_FLAGS_ENABLED) {
  FlagsService.init().then(() => {
    // eslint-disable-next-line
    console.log('Feature flags enabled')
  })
}

function App () {
  const [appInited, setAppInited] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isOnboarding, setIsOnboarding] = useState(false)
  const [invitationCode, setInvitationCode] = useState(false)
  const [play] = useSound(notificationSound)
  
  CommonsService.history = useHistory()
  CommonsService.play = play

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const code = query?.get('invite')
    setInvitationCode(code)
    
    store.on('APP:inited', () => setAppInited(true))
    store.on('APP:is_loading', (loading) => setIsLoading(loading))
    store.on('USER:logged', (isLogged) => {
      if (isLogged) {
        log.marKNow('INIT SESSION')
        sessionService.initSession().then((meStatus) => {
          if (meStatus === 'onboarding' || meStatus === 'byod_pending') {
            setIsOnboarding(true)
            setIsLoading(false)
          }
        })
      }
    })
  }, [])
  
  return (
    <KBarProvider>
      <KbarInput />
      <div className='app-container'>
        { invitationCode && <Redirect to={`/auth/signup?invite=${invitationCode}`}/> }
        { isOnboarding && sessionService.getUserStatus() === 'byod_pending' && !CommonsService.urlIncludesString('auth/signup') && <Redirect to='/auth/signup/byod-setup-step'/> }

        {appInited && !isLoading
          ? <Switch>
            <Route path="/auth" component={LoginPage} />
            { !isOnboarding &&
            <>
              <HeadersMenu/>
              <Switch>
                <Route path="/settings" component={SettingsPage} />
                <Route exact path="/drafts" component={HomePage} />
                <Route exact path="/contacts" component={HomePage} />
                <Route exact path="/history" component={HomePage} />
                <Route exact path="/boxes" component={HomePage} />
                <Route exact path="/" component={HomePage} />
                <Route exact path="/write" component={HomePage} />
              </Switch>
              <DropdownMenu/>
              <MessageModal/>
            </>
          }

            { isOnboarding && sessionService.getUserStatus() !== 'byod_pending' && !CommonsService.urlIncludesString('auth/signup') && <Redirect to='/auth/signup/domain-selection'/> }

          </Switch>
          : <LoadingScreen />}
        <SessionExpiredModal/>
        <div id="appModalContainer"></div>
        <div id="appToastContainer"></div>
      </div>
    </KBarProvider>
  )
}

export default withLDProvider({
  clientSideID: '62396f19f1543014a6e0e3d9',
})(App)
